var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',{class:_vm.classes,on:{"tap":function($event){return _vm.$emit('tap', $event)},"click":function($event){return _vm.$emit('click', $event)},"touch":function($event){return _vm.$emit('touch', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }